import React from "react";
import { TableComponent } from "./TableComponent";

// Simple table display component without modal dependencies
export const TableDisplay = ({ preparedRows, itemsPerPage = 100, showPager = false, ...props }) => {
   return (
      <TableComponent
         preparedRows={preparedRows}
         itemsPerPage={itemsPerPage}
         showPager={showPager}
         {...props}
      />
   );
};
